import { Trans, useTranslation } from 'react-i18next';

const buildPages = (current, total) => {
  const pages = [];
  const push = (v) => {
    if (pages[pages.length - 1] !== v) pages.push(v);
  };
  if (total <= 7) {
    for (let i = 1; i <= total; i++) push(i);
    return pages;
  }
  push(1);
  if (current > 3) push('...');
  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  for (let i = start; i <= end; i++) push(i);
  if (current < total - 2) push('...');
  push(total);
  return pages;
};

const Pagination = ({
  currentPage,
  totalPages,
  totalItems,
  pageSize,
  onPageChange,
  className = '',
}) => {
  const { t } = useTranslation();
  if (totalPages <= 1) return null;
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math.min(currentPage * pageSize, totalItems);
  const pages = buildPages(currentPage, totalPages);

  const go = (p) => {
    if (p < 1 || p > totalPages || p === currentPage) return;
    onPageChange(p);
  };

  const btnBase =
    'min-w-[2.25rem] h-9 px-2 rounded-md border text-sm transition-colors disabled:opacity-40 disabled:cursor-not-allowed';

  return (
    <div
      className={`flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mt-4 ${className}`}
    >
      <div className="text-sm text-slate-600 dark:text-slate-300">
        <Trans
          i18nKey="common.pagination.showing"
          values={{ start: startItem, end: endItem, total: totalItems }}
          components={{ b: <span className="font-medium" /> }}
        />
      </div>
      <div className="flex items-center gap-1 flex-wrap">
        <button
          type="button"
          onClick={() => go(currentPage - 1)}
          disabled={currentPage === 1}
          className={`${btnBase} border-slate-300 dark:border-slate-700 text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800`}
          aria-label={t('common.pagination.previous')}
        >
          ‹
        </button>
        {pages.map((p, i) =>
          p === '...' ? (
            <span key={`e-${i}`} className="px-2 text-slate-400 dark:text-slate-400">
              …
            </span>
          ) : (
            <button
              key={p}
              type="button"
              onClick={() => go(p)}
              className={`${btnBase} ${
                p === currentPage
                  ? 'bg-primary-600 text-white border-primary-600'
                  : 'border-slate-300 dark:border-slate-700 text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800'
              }`}
              aria-current={p === currentPage ? 'page' : undefined}
            >
              {p}
            </button>
          )
        )}
        <button
          type="button"
          onClick={() => go(currentPage + 1)}
          disabled={currentPage === totalPages}
          className={`${btnBase} border-slate-300 dark:border-slate-700 text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800`}
          aria-label={t('common.pagination.next')}
        >
          ›
        </button>
      </div>
    </div>
  );
};

export default Pagination;
